import { Popup } from "semantic-ui-react";
import { useUser } from "../../contexts/useUserData";
import { useState } from "react";
import { useChat } from "../../contexts/useChatData";
import { useMediaQuery } from "@react-hook/media-query";
import "semantic-ui-css/semantic.min.css";

interface propsType {
    content: string; // El texto de la pregunta del historial
    menuOpen: Function; // Función para manejar el menú lateral si es necesario
}

export const PopupHistQuestions = (propsData: propsType) => {
    const { isLoading } = useChat(); // Indica si hay operaciones en curso
    const { isHistQuestionClicked } = useUser();
    const isResponsive = useMediaQuery("only screen and (max-width: 768px)");
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        if (!isLoading) {
            // Aquí puedes añadir lógica específica para preguntas del historial
            isHistQuestionClicked!(true, propsData.content);
            console.log("Historial seleccionado:", propsData.content);
            if (isResponsive) {
                propsData.menuOpen();
            }
        }
        setIsOpen(false);
    };

    return (
        <Popup
            trigger={
                <p
                    id="popup-history"
                    onClick={() => {
                        if (!isLoading) {
                            if (isResponsive) {
                                handleClick();
                            } else {
                                isHistQuestionClicked!(true, propsData.content);
                            }
                        }
                    }}
                >
                    {propsData.content}
                </p>
            }
            position={isResponsive ? "top center" : "right center"}
            on={isResponsive ? "click" : "hover"}
            open={isResponsive ? isOpen : undefined}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            disabled={isLoading}
        >
            <div onClick={handleClick}>
                {propsData.content}
            </div>
        </Popup>
    );
};